export default "__VITE_ASSET__DVY4JKwI__"